import React from 'react'

function Accord() {
  return (
    <div>
        <div class="accord js-accord">
        <div class="accord__center center">
          <div class="accord__row">
            <div class="accord__details">
              <div class="accord__top" data-aos="animation-scale-y">
                <div class="accord__title title title_sm">Technological maturity.</div>
                <div class="accord__text">Collab is fast. Files are always up to date and ready for production. </div>
              </div>
              <ul class="accord__list" data-aos="animation-scale-y" data-aos-delay="200">
                <li>Collab Cloud</li>
                <li>Collab Design</li>
                <li>Collab Share</li>
                <li>Collab Code</li>
              </ul>
            </div>
            <div class="accord__wrap">
              <div class="accord__item js-accord-item active" data-aos="animation-scale-y">
                <div class="accord__head js-accord-head">
                  <div class="accord__icon"><img class="accord__pic" src="img/layout-3.svg" alt=""/></div>
                  <div class="accord__category">In research</div>
                </div>
                <div class="accord__body js-accord-body" style={{display: "block", backgroundImage: `url('img/accord-pic.png')`}}>
                  <ul class="accord__desc">
                    <li>3+ user</li>
                    <li>5 TB of secure storage</li>
                    <li>Premium productivity features and simple, secure file sharing</li>
                  </ul>
                </div>
              </div>
              <div class="accord__item js-accord-item" data-aos="animation-scale-y">
                <div class="accord__head js-accord-head">
                  <div class="accord__icon"><img class="accord__pic" src="img/layout-3.svg" alt=""/></div>
                  <div class="accord__category">Drafted</div>
                </div>
                <div class="accord__body js-accord-body" style={{backgroundImage: `url('img/accord-pic.png')`}}>
                  <ul class="accord__desc">
                    <li>3+ user</li>
                    <li>5 TB of secure storage</li>
                    <li>Premium productivity features and simple, secure file sharing</li>
                  </ul>
                </div>
              </div>
              <div class="accord__item js-accord-item" data-aos="animation-scale-y">
                <div class="accord__head js-accord-head">
                  <div class="accord__icon"><img class="accord__pic" src="img/layout-3.svg" alt=""/></div>
                  <div class="accord__category">In development</div>
                </div>
                <div class="accord__body js-accord-body" style={{backgroundImage: `url('img/accord-pic.png')`}}>
                  <ul class="accord__desc">
                    <li>3+ user</li>
                    <li>5 TB of secure storage</li>
                    <li>Premium productivity features and simple, secure file sharing</li>
                  </ul>
                </div>
              </div>
              <div class="accord__item js-accord-item" data-aos="animation-scale-y">
                <div class="accord__head js-accord-head">
                  <div class="accord__icon"><img class="accord__pic" src="img/layout-3.svg" alt=""/></div>
                  <div class="accord__category">Proposed</div>
                </div>
                <div class="accord__body js-accord-body" style={{backgroundImage: `url('img/accord-pic.png')`}}>
                  <ul class="accord__desc">
                    <li>3+ user</li>
                    <li>5 TB of secure storage</li>
                    <li>Premium productivity features and simple, secure file sharing</li>
                  </ul>
                </div>
              </div>
              <div class="accord__item js-accord-item" data-aos="animation-scale-y">
                <div class="accord__head js-accord-head">
                  <div class="accord__icon"><img class="accord__pic" src="img/layout-3.svg" alt=""/></div>
                  <div class="accord__category">Completed</div>
                </div>
                <div class="accord__body js-accord-body" style={{backgroundImage: `url('img/accord-pic.png')`}}>
                  <ul class="accord__desc">
                    <li>3+ user</li>
                    <li>5 TB of secure storage</li>
                    <li>Premium productivity features and simple, secure file sharing</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  )
}

export default Accord